import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateAtticCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction) return undefined;

  const {
    attic,
    craftsmanQuality: craftsmanDwellingQuality,
    propertyType,
  } = improvementsForTransaction;

  const zipCode = identification?.address.PostalCode;
  if (
    !attic ||
    isUndefined(craftsmanDwellingQuality) ||
    !identification ||
    isUndefined(zipCode) ||
    isUndefined(attic.area)
  ) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getAtticCost({
    hasFeature: ORDER_FEATURES.attic.hasFeature(improvementsForTransaction),
    sqft: AloftArea.schema.parse(attic.area),
    quality: attic.quality ?? craftsmanDwellingQuality,
    propertyType: propertyType ?? 'singleFamilyResidence',
    zipCode,
  });
};

export const { selectAtticCost, selectZipOnlyAtticCost, selectAtticCosts, selectAtticCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculateAtticCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectAtticCost',
      zipOnly: 'selectZipOnlyAtticCost',
      costs: 'selectAtticCosts',
      display: 'selectAtticCostDisplay',
    },
  });
